<div class="transfer-history">
	<div class="section-header" i18n>{{header}}</div>

	<div *ngIf="!transferHistory.length" class="no-records">
		No records of transfer requests available.
	</div>

	<div *ngIf="transferHistory.length" class="transfer-history-list">
		<div class="section-details" *ngFor="let transfer of transferHistory">
			<a class="label" (click)="viewTransferDetails(transfer)">{{transfer['createdAt']}} </a>
			<label class="label"> ({{transfer['result']}})</label>
		</div>
	</div>
</div>
